import * as axiosHelper from "./api_helper";


// forex live
export const registerClient = async(params) =>{
  try {
    const { user } = params;
    let url = "/register";
    delete user.accountType;
    delete user.history;
    delete user.confirmPassword;
    delete user.search;
    const result = axiosHelper.post(url, user);
    return result;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const checkUserEmailApi = async (payload)=>{
  try {
    const { payload:{ email } } = payload ;
    const result = await axiosHelper.get(`/customer/check-email?email=${email}`);
    return result;
  } catch (err){
    throw new Error(err.message);
  }
};

export const sendEmailPinAPI = async ({ email })=>{
  try {
    const resp = await axiosHelper.post("/register/send-pin", {
      email: email,
    });
    if (resp.status) {
      return resp;
    }
    else return resp.message;
  } catch (error) {
    return error.message;
  }
};

export const sendEmailPinAPILogin = async ({ email, isRegister })=>{
  try {
    const resp = await axiosHelper.post("/register/send-pin-login", {
      email: email,
      isRegister
    });
    if (resp.status) {
      return resp;
    }
    else return resp.message;
  } catch (error) {
    return error.message;
  }
};

export const getUserPin = async ({ email })=>{
  try {
    const resp = await axiosHelper.get("/register/get-user?email=" + email);
    if (resp) {
      return resp;
    }
    else return resp.message;
  } catch (error) {
    return error.message;
  }
};


export const verifyEmailPinAPI = async ({ email, emailPin })=>{
  try {
    const resp = await axiosHelper.post("/register/verify-pin", {
      email: email,
      emailPin: emailPin
    });
    if (resp.status) {
      return resp;
    }
    else return resp.message;
  } catch (error) {
    return error.message;
  }
};